import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'container']
  connect () {

  }

  toggle (e) {
    for (let container of this.containerTargets) {
      container.classList.toggle('hidden')
    }
  }
}
